import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <main className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="glass rounded-3xl p-10 max-w-md text-center rise">
        <h1 className="font-display text-3xl font-extrabold mb-2">Payment cancelled</h1>
        <p className="text-slate-300 mb-6">Your booking wasn't completed. Try again anytime.</p>
        <Link to="/browse"><Button className="bg-white text-slate-950 hover:bg-slate-100 font-semibold">Keep browsing</Button></Link>
      </div>
    </main>
  );
}
